import ActionTypes from "../constants/ActionTypes";

const defaultState = {
    navHeight: 137,
    navVisible: true,
    alertModal: {
        open: false,
        title: "",
        message: "",
    },
};

function uiReducer(state = defaultState, action) {
    switch (action.type) {
        case ActionTypes.SET_NAV_HEIGHT:
            return {
                ...state,
                navHeight: action.height,
            };
        case ActionTypes.HIDE_NAV:
            return {
                ...state,
                navVisible: false,
            };
        case ActionTypes.SHOW_NAV:
            return {
                ...state,
                navVisible: true,
            };
        case ActionTypes.INVERT_NAV:
            return {
                ...state,
                navInvert: true,
            };
        case ActionTypes.UNINVERT_NAV:
            return {
                ...state,
                navInvert: false,
            };
        case ActionTypes.OPEN_ACCOUNT_MODAL:
            return {
                ...state,
                accountModal: true,
            };
        case ActionTypes.UNOPEN_ACCOUNT_MODAL:
            return {
                ...state,
                accountModal: false,
            };
        case ActionTypes.OPEN_ALERT_MODAL:
            return {
                ...state,
                alertModal: {
                    open: true,
                    title: action.title,
                    message: action.message,
                },
            };
        case ActionTypes.UNOPEN_ALERT_MODAL:
            return {
                ...state,
                alertModal: {
                    ...state.alertModal,
                    open: false,
                },
            };
        case ActionTypes.SET_CHECKOUT_NAV:
            return {
                ...state,
                navCheckout: true,
            };
        case ActionTypes.UNSET_CHECKOUT_NAV:
            return {
                ...state,
                navCheckout: false,
            };
        case ActionTypes.SET_SIMPLE_NAV:
            return {
                ...state,
                navSimple: true,
            };
        case ActionTypes.UNSET_SIMPLE_NAV:
            return {
                ...state,
                navSimple: false,
            };
        case ActionTypes.SET_NO_NAV:
            return {
                ...state,
                navHide: true,
            };
        case ActionTypes.UNSET_NO_NAV:
            return {
                ...state,
                navHide: false,
            };
        case ActionTypes.SET_HISTORY_BACK:
            return {
                ...state,
                goBack: action.goBack,
            };
        case ActionTypes.CLEAR_HISTORY_BACK:
            return {
                ...state,
                goBack: null,
            };
        case ActionTypes.SET_PREVIOUS_PAGE:
            return {
                ...state,
                previousPage: action.previousPage,
            };
        default:
            return state;
    }
}

export default uiReducer;
